import React, { useEffect, useState } from "react";
import adminService from "../../Services/adminService";

export default function DisplayMembersSummary() {
  const [membersData, setMembersData] = useState(null);

  useEffect(() => {
    const role = localStorage.getItem("role");
    if (role === "admin" || role === "salesManager") {
      adminService.adminGetMembersData().then((res) => {
        if (res.success) {
          setMembersData(res.data);
        }
      });
    }
  }, []);

  return (
    <>
      {membersData ? (
        <div className="admin-users-data-con">
          <table>
            <tbody>
              <tr>
                <td>סך כל המשתמשים</td>
                <td>{membersData.totalMembersAmount}</td>
              </tr>
            </tbody>
            <tbody>
              <tr>
                <td>משתמשים פעילים</td>
                <td>{membersData.activeMembers}</td>
              </tr>
            </tbody>
            <tbody>
              <tr>
                <td>לא פעילים</td>
                <td>{membersData.totalMembersAmount - membersData.activeMembers}</td>
              </tr>
            </tbody>
          </table>
        </div>
      ) : null}
    </>
  );
}
